import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';

@Component({
  selector: 'cv-marketplace-shopping-cart-wishlist',
  templateUrl: './cv-marketplace-shopping-cart-wishlist.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart-wishlist.component.scss']
})
export class CvMarketplaceShoppingCartWishlistComponent implements OnInit, OnDestroy {

  @Output() clearSearch = new EventEmitter<string>();
  @Output() showValidationMsg = new EventEmitter<any>();

  pscs = null;
  sortBy: string = 'PriceLowToHigh';
  sortOptions = [];
  selectedSortOption: any;
  localizationStrings = new Map();

  cardWidth: string = '0%';
  @ViewChild('wishlistContainer') wishlistContainerER: ElementRef;
  wishlistContainerWidth: number = 0;
  wishlistContainerObserver: any = null;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private cvLocalizationService: CVLocalizationService,
    private CvNumberLocalizePipe: CvNumberLocalizePipe,
    private changeDetector?: ChangeDetectorRef,
  ) {
    this.pscs = shoppingCartService.shoppingCartObj;
  }

  ngOnInit(): void {
    this.loadData();
  }

  async loadData(){
    this.setCardsWidth(true);
    this.loadLocalizations();
    setTimeout(() => {
      this.pscs.shoppingCartIsProductSelected = false;
    }, 0);
    await this.loadLocalizations();
    this.clearSearch.emit();
    if (this.pscs.shoppingCartActiveTab == 'WISHLIST') {
      if (this.pscs.shoppingCartLandingSortBy != '') {
        this.sortBy = this.pscs.shoppingCartLandingSortBy;
        let selectedSortOption = this.sortOptions.find(element => element.value == this.sortBy);
        if (selectedSortOption != null)
          this.selectedSortOption = selectedSortOption;
      } else {
        this.pscs.shoppingCartLandingSortBy = this.sortBy;
      }
      this.sortProducts(this.sortBy);
    } else {
      this.pscs.shoppingCartLandingSortBy = this.selectedSortOption;
      this.sortProducts(this.selectedSortOption);
    }
    this.pscs.shoppingCartActiveTab = 'WISHLIST';
  }

  ngOnDestroy(): void {
    if (this.wishlistContainerObserver) {
      this.wishlistContainerObserver.disconnect();
    }
  }

  async loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
      this.localizationStrings = map;
      this.loadsortOptionsLocalizations();
    });
  }

  
  loadsortOptionsLocalizations() {
    this.sortOptions = [
      { value: 'PriceLowToHigh', name: this.getLocalizationString('Price_Low_To_High', 'Price: Low To High') },
      { value: 'PriceHighToLow', name: this.getLocalizationString('Price_High_To_Low', 'Price: High To Low') },
      { value: 'TitleAToZ', name: this.getLocalizationString('Title_A_To_Z', 'Title: A To Z') },
      { value: 'TitleZToA', name: this.getLocalizationString('Title_Z_To_A', 'Title: Z To A') }
    ];
    this.selectedSortOption = this.sortOptions[0];
  }

  getLocalizationString(key, defaultValue) {
    if (this.localizationStrings && this.localizationStrings.has(key))
      return this.localizationStrings.get(key);
    return defaultValue;
  }

  isPriceLabelTooLong(product) {
    let value = String(this.getProductPrices(product));
    if (value.includes("-")) {
      return value.length > 11;
    } else {
      return new CvNumberLocalizePipe().transform(value).length > 6 && product.Sale != null && this.isCurrentSale(product);
    }
  }

  getProductPrices(product) {
    if (product != null) {
      if (product.HasProductVariations && product.HasVariationPrices && product.VariationsData != null && product.VariationsData.length) {
        let initialVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue < currValue ? prev : curr;
        });
        let lastVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue > currValue ? prev : curr;
        });
        let initialVariationPrice = initialVariation.VariationOnSale ? (initialVariation.VariationPrice - (initialVariation.VariationPrice * (product.Sale / 100))) : initialVariation.VariationPrice;
        let lastVariationPrice = lastVariation.VariationOnSale ? (lastVariation.VariationPrice - (lastVariation.VariationPrice * (product.Sale / 100))) : lastVariation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(initialVariationPrice)) + " - " + new CvNumberLocalizePipe().transform(Math.ceil(lastVariationPrice));
      }
      else if (product.Sale != null && this.isCurrentSale(product)) {
        return product.CalculatedRealPrice;
      } else
        return product.Price;
    }
  }

  isCurrentSale(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 1);
    }

    return false;
  }

  isFeatured(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 2);
    }

    return false;
  }

  openProductDetails(product) {
    this.pscs.shoppingCartIsProductSelected = true;
    this.pscs.pointStoreDetailedViewProduct = product;
    if (this.pscs.pointStoreDetailedViewProduct.HasProductVariations) {
      this.pscs.pointStoreDetailedViewProduct.VariationsData = this.pscs.pointStoreDetailedViewProduct.VariationsData.filter(v => v.Active);
    }
  }

  isOutOfStock(product): any {
    if (product != null) {
      if (product.HasProductVariations && product.VariationsData != null && product.VariationsData.length > 0) {
        let variationsOutOfStock = 0;
        product.VariationsData.forEach(variation => {
          if (variation.VariationQuantity === 0)
            variationsOutOfStock++;
        });
        return variationsOutOfStock == product.VariationsData.length;
      } else {
        return product.Quantity == 0 || product.Quantity < 0;
      }
    } else
      return false;
  }

  getImagesCount(product) {
    let count = 0;
    if (product.MultipleImagesData != null && product.MultipleImagesData.length > 1) {
      let mainImages = product.MultipleImagesData.filter((i) => { return i.PointStoreProductVariationID == null || i.PointStoreProductVariationID == 0; });
      count = mainImages != null ? mainImages.length : 0;

      if (product.VariationsData != null && product.VariationsData.length > 0) {
        let variationImages = product.VariationsData.map((v) => {
          if (v.Active == null || v.Active)
            return v.PointStoreProductVariationID;
        });
        product.MultipleImagesData.forEach((currentValue, index, array) => {
          if (variationImages.includes(currentValue.PointStoreProductVariationID))
            count++;
        });
      }
      return count - 1;
    } else {
      return 1
    }
  }

  sortProducts(sortBy) {
    if (sortBy == null)
      sortBy = this.sortBy
    else
      this.sortBy = sortBy;

    this.pscs.shoppingCartLandingSortBy = this.sortBy

    switch (this.sortBy) {
      case "PriceLowToHigh":
      default:
        this.pscs.shoppingCartWishlistProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceA) - parseFloat(priceB);
        });
        break;
      case "PriceHighToLow":
        this.pscs.shoppingCartWishlistProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceB) - parseFloat(priceA);
        });
        break;
      case "TitleAToZ":
        this.pscs.shoppingCartWishlistProducts.sort((a, b) => a.Title.localeCompare(b.Title));
        break;
      case "TitleZToA":
        this.pscs.shoppingCartWishlistProducts.sort((a, b) => b.Title.localeCompare(a.Title));
        break;
    }
  }

  async wishlistAction(product, $event) {
    $event.stopPropagation();
    if (product.isInWhisList)
      await this.removeFromWishlist(product)
    else
      await this.addToWishlistProduct(product);
    if (this.sortBy != null) {
      this.sortProducts(this.sortBy);
    } else {
      this.pscs.shoppingCartLandingSortBy = this.selectedSortOption;
      this.sortBy = this.pscs.shoppingCartLandingSortBy;
      this.sortProducts(this.selectedSortOption);
    }
  }

  async removeFromWishlist(product) {
    let response = await this.shoppingCartService.removeWishlistItem(product);
    if (response)
      this.showValidationMsg.emit({ event: event, isAdding: false });
  }

  async addToWishlistProduct(product) {
    let response = await this.shoppingCartService.addWishlistItem(product);
    if (response)
      this.showValidationMsg.emit({ event: event, isAdding: true });
  }

  isMainImageEmptyWithMultiplesImages(product): boolean{
    let status = false;
    if(product.HasMultipleImages && (product.ProductImageID == 0 || product.ProductImageID == null))
    {
      status = true;
    } else {
      status = false;
    }
    return status;
  }

  getFirstVariationImage(product: any): any {
    let firstVariationImage;
    if(product && product.MultipleImagesData && product.MultipleImagesData.length > 0){
      firstVariationImage = product.MultipleImagesData[0].PointStoreProductImageID;
    }
    return firstVariationImage;
  }
  
  reduceLongPriceLength(longPrice: string): string{
    if (longPrice.length > 19){
      return (longPrice.substring(0, 17) + "...");
    } else{
      return longPrice;
    }
  }


  /**
 * calculate card width based on the content size.
 */
  calculateCardsWidth() {
    const upperTabsContent = document.getElementsByClassName('upper-tabs-content');
    if (upperTabsContent) {
      const elementFromUpperTabsContent = upperTabsContent[0] as HTMLElement;
      if (elementFromUpperTabsContent.offsetWidth >= 1770) {
        //7 cards by row
        this.cardWidth = '14.28571428571429%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1769 && elementFromUpperTabsContent.offsetWidth >= 1470) {
        //6 cards by row
        this.cardWidth = '16.66666666666667%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1469 && elementFromUpperTabsContent.offsetWidth >= 1270) {
        //5 cards by row
        this.cardWidth = '20%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1269 && elementFromUpperTabsContent.offsetWidth >= 1070) {
        //4 cards by row
        this.cardWidth = '25%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1069 && elementFromUpperTabsContent.offsetWidth >= 830) {
        //3 cards by row
        this.cardWidth = '33.33%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 829 && elementFromUpperTabsContent.offsetWidth >= 600) {
        //2 cards by row
        this.cardWidth = '50%';
      } else {
        //1 card by row
        this.cardWidth = '100%';
      }
    } else {
      this.cardWidth = '20%';
    }
  }

  /**
 * set the card width based on the width of 'upper-tabs-content', Use the calculateCardsWidth() function
 */
  setCardsWidth(firstLoading: boolean): void {
    this.calculateCardsWidth();
    this.changeDetector.detectChanges();
    if (firstLoading) {
      setTimeout(() => {
        this.configureCardsWidth();
        this.configureResizeObserver();
      }, 0);
    } else {
      this.configureCardsWidth();
    }
  }

  /**
 * configure the wishlistContainerWidth variable. 
 */
  configureCardsWidth() {
    if (this.wishlistContainerER) {
      this.wishlistContainerWidth = this.wishlistContainerER.nativeElement.offsetWidth;
    } else {
      this.wishlistContainerWidth = 1;
    }
  }

  /**
   * configure resize observer
   */
  configureResizeObserver() {
    this.wishlistContainerObserver = new ResizeObserver(entries => {
      if (this.wishlistContainerER) {
        // Adjust the width of the card according to the width of the container.
        if (this.wishlistContainerER.nativeElement.offsetWidth !== 0 &&
          this.wishlistContainerWidth !== 0 &&
          this.wishlistContainerER.nativeElement.offsetWidth !== this.wishlistContainerWidth) {
          this.setCardsWidth(false);
        }
      }
    });
    const divToObserve = document.getElementById('wishlist-container');
    this.wishlistContainerObserver.observe(divToObserve);
  }
}
